import { ToastData } from './toast.type';
import { toastSubject } from './toast-container';

let id = 0;

type ToastOptions = Omit<ToastData, 'id'>;

export function addToast({ type = 'success', delay = 3000, description, title }: ToastOptions) {
  const toasts = [...toastSubject.getValue()];

  toasts.push({
    id: ++id,
    type,
    description,
    title,
    delay,
  });

  toastSubject.next(toasts);
}
